import { all } from 'redux-saga/effects';

import thankYouSaga from './thankYou-saga';

export default function* rootSaga() {
  yield all([thankYouSaga()]);
}
